export default "__VITE_ASSET__39vBXp68__"